// extracted by mini-css-extract-plugin
module.exports = {"navIco":"nav_navIco__7flDF","sizeLogo":"nav_sizeLogo__1F7qX","sizeLogo5":"nav_sizeLogo5__nrVsT"};